import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Gate any route by authentication + optional role.
 * - role="admin"  → admin@myecotour.com style users
 * - role="partner" → reseller / channel partner users
 * - role unset → any logged-in user
 */
export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
                <span className="text-sm tracking-[0.25em] uppercase">Verifying…</span>
            </div>
        );
    }
    if (!user) {
        const loginPath = role === "partner" ? "/partner/login" : "/admin/login";
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }
    // Logged in but wrong role → bounce them to their correct portal landing
    if (role && user.role !== role) {
        return <Navigate to={user.role === "partner" ? "/partner" : "/admin"} replace />;
    }
    return children;
}
